module.exports = __webpack_public_path__ + "static/img/icon_year_en.da0b3eb7.jpg";